import { AdditionalEmployeeInfo, EducationDegree } from "./employee";

export enum ApplicationStatus {
  SUBMITTED = "SUBMITTED",
  VIEWED = "VIEWED",
  NOT_CONSIDERED = "NOT_CONSIDERED",
  WITHDRAWN = "WITHDRAWN",
  INTERVIEW = "INTERVIEW",
  NOT_SELECTED = "NOT_SELECTED",
  HIRED = "HIRED",
  OFFER = "OFFER",
  ON_HOLD = "ON_HOLD"
}

export enum WithdrawApplicationReason {
  FOUND_ANOTHER_OPPORTUNITY = "FOUND_ANOTHER_OPPORTUNITY",
  CHANGE_IN_CAREER_GOALS = "CHANGE_IN_CAREER_GOALS",
  NOT_INTERESTED_IN_THIS_ROLE = "NOT_INTERESTED_IN_THIS_ROLE",
  OTHER = "OTHER",
  ADMIN_WITHDRAW = "ADMIN_WITHDRAW",
  NONE = "NONE"
}

export enum ApplicationStatusEvent {
  NEXT_STEP = "NEXT_STEP",
  REJECT = "REJECT",
  ON_HOLD = "ON_HOLD",
  WITHDRAW = "WITHDRAW",
  RESET = "RESET"
}

export enum ApplicationStatusSteps {
  OFFER = "Offer",
  INTERVIEW = "Interview",
  IN_REVIEW = "In review",
  SUBMITTED = "Submitted",
  NOT_SELECTED = "Not selected",
  NOT_CONSIDERED = "Not considered",
  WITHDRAWN = "Withdrawn",
  HIRED = "Hired",
  ON_HOLD = "On hold"
}

export enum UpdateApplicationStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  APPLICATION_NOT_FOUND = "APPLICATION_NOT_FOUND"
}

interface ApplicationJobInfo {
  jobTitle: string;
  jobLocation: string;
  totalPay: string;
  jobRole: string;
  jobLevel: string;
  jobType: string;
  duration: string;
}

export interface Application {
  id: string;
  jobId: string;
  employeeId: string;
  resumeUrl: string;
  status: ApplicationStatus;
  lastUpdated: string;
  submittedDate: string;
  lastUpdateBy: string;
  jobInfo: ApplicationJobInfo;
  withdrawReason: WithdrawApplicationReason;
  previousStatus: ApplicationStatus;
}

export interface CreateApplicationResponse {
  createApplication: {
    application: Application;
  };
}

export interface ApplicationFormData {
  schoolName: string;
  degree: EducationDegree;
  concentration: string;
  linkedInUrl?: string;
  portfolioUrl?: string;
  githubUrl?: string;
  resume: File;
}

export interface CreateApplicationVariable {
  employeeId: string;
  jobId: string;
  additionalEmployeeInfo: AdditionalEmployeeInfo;
}

export interface UpdateApplicationInput {
  applicationId: string;
  status: ApplicationStatus;
}

export interface UpdateApplicationResponse {
  status: UpdateApplicationStatus;
  application: Application;
}

export interface GetApplicationListResponse {
  getApplicationListByMemberId: Application[];
}

export interface WithdrawApplicationInput {
  applicationId: string;
  memberId: string;
  withdrawReason: WithdrawApplicationReason;
}

export interface WithdrawApplicationFormData {
  withdrawReason: WithdrawApplicationReason;
}

export interface WithdrawApplicationResponse {
  withdrawApplication: UpdateApplicationResponse;
}

export interface getAdminApplicationListResponse {
  adminGetApplicationList: Application[];
}

export interface getAdminApplicationListRequest {
  email?: string;
  phone?: string;
  jobId?: string;
  memberId?: string;
  postingStatus?: ApplicationStatus;
}

export interface getApplicationByIdResponse {
  adminGetApplicationById: Application;
}

export interface ApplicationButtonConfigType {
  title: string;
  allowedActions: ApplicationStatus[];
  event: ApplicationStatusEvent;
  color:
    | "error"
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "info"
    | "warning";
}

export interface AdminUpdateApplicationResponse {
  adminUpdateApplication: Application;
}

export interface AdminUpdateApplicationInput {
  applicationId: string;
  updatedBy: string;
  applicationStatusEvent: ApplicationStatusEvent;
  withdrawReason?: WithdrawApplicationReason;
}
